export class Collaborator {
    _id : string;
    companyId : string;
    name : string;
    phone: string;
    email : string;
}

